import BsXCircle from '@meronex/icons/bs/BsXCircle';
import React, { useEffect, useMemo } from 'react';
import { getConfig } from '../../../utils/config';
import { useData } from './data';
import Select from 'react-select';
import qs from 'qs';
import PhoneInput from 'react-phone-input-2';
import { authActions } from '../../../store/auth-slice';
import { winnreAuth } from '../../../utils/axios';
import countryList from 'react-select-country-list';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { isBrigade } from '../../../helpers';
import { LoadingSpinner } from '../../Molecules/LoadingUI';
function SignUp({
    backHandler,
    closeLoginModal,
    isInternationalCustomer,
    selectedOption,
    createRegistration,
    email,
    emailBlurHandler,
    emailChangedHandler,
    emailHasError,
    emailIsValid,
    setAlertMessage,
    setShowErrorAlert,
    loginWithEmail
}) {
    const config = getConfig();
    const [loading, setLoading] = React.useState(false);
    // console.log("config?.loginModal?.skipReraNumberValidation", config?.loginModal?.skipReraNumberValidation);
    const dispatch = useDispatch();
    const history = useHistory();
    const {
        state: {
            name,
            nameIsValid,
            nameHasError,
            unitNumber,
            unitNumberIsValid,
            unitNumberHasError,
            currentMobile,
            currentCountry,
            currentMobileHasError,
            project,
            projectList,
            unitValidated,
            currentMobileNumberIsValid,
            companyName,
            companyNameIsValid,
            companyNameHasError,
            companyTypes,
            companyType,
            addressLine1,
            addressLine1IsValid,
            addressLine1HasError,
            addressLine2,
            city,
            cityList,
            stateVal,
            stateList,
            stateIsValid,
            stateHasError,
            pincode,
            pincodeIsValid,
            pincodeHasError,
            country,

            countryIsValid,
            countryHasError,
            panNumber,
            panNumberIsValid,
            panNumberHasError,
            reraNumber,
            reraNumberIsValid,
            reraNumberHasError
        },
        resetName,
        resetUnitNumber,
        nameChangedHandler,
        nameBlurHandler,
        unitNumberChangedHandler,
        unitNumberBlurHandler,
        getCurrentMobileWithoutCountryCode,
        setCurrentMobileIsTouched,
        setCurrentMobileInputFocused,
        currentMobileOnChange,
        currentMobileValidtor,
        setProject,
        getProjects,
        setUnitValidated,
        companyNameChangedHandler,
        companyNameBlurHandler,
        resetCompanyName,
        setCompanyType,
        addressLine1ChangedHandler,
        addressLine1BlurHandler,
        resetAddressLine1,
        addressLine2ChangedHandler,
        addressLine2BlurHandler,
        resetAddressLine2,
        cityChangedHandler,
        cityBlurHandler,
        resetCity,
        stateChangedHandler,
        stateBlurHandler,
        resetState,
        pincodeChangedHandler,
        pincodeBlurHandler,
        resetPincode,
        countryChangedHandler,
        countryBlurHandler,
        resetCountry,
        panNumberChangedHandler,
        panNumberBlurHandler,
        resetpanNumber,
        reraNumberChangedHandler,
        reraNumberBlurHandler,
        resetReraNumber
    } = useData(isInternationalCustomer, loginWithEmail);

    useEffect(() => {
        if (companyType === 'INDIVIDUAL') {
            resetCompanyName();
        }
    }, [companyType, resetCompanyName]);

    const options = useMemo(() => countryList().getData(), []);

    let formIsValid = false;
    if (selectedOption === 'CHANNEL_PARTNER') {
        const baseValidation =
            nameIsValid &&
            addressLine1IsValid &&
            stateIsValid &&
            countryIsValid &&
            pincodeIsValid &&
            (config?.loginModal?.skipReraNumberValidation === true ? panNumberIsValid : reraNumberIsValid) &&
            (companyType !== 'COMPANY' || companyNameIsValid);
        if (isInternationalCustomer || loginWithEmail) {
            formIsValid = baseValidation && currentMobileNumberIsValid;
        } else {
            formIsValid = baseValidation && emailIsValid;
        }
    }

    const backClickedHandler = () => {
        resetName();
        resetCompanyName();
        resetAddressLine1();
        resetAddressLine2();
        resetCity();
        resetState();
        resetPincode();
        resetCountry();
        resetpanNumber();
        resetReraNumber();
        setCompanyType('COMPANY');
        backHandler();
    };

    const registrationHandler = (e) => {
        e.preventDefault();

        if (selectedOption === 'CHANNEL_PARTNER') {
            const storedUser = sessionStorage.getItem('user');
            const userData = storedUser ? JSON.parse(storedUser) : null;

            let finalEmail = '';
            let finalMobileCountryCode = '';
            let finalMobileNumber = '';

            if (!isInternationalCustomer && !loginWithEmail) {
                // Email input was visible
                finalEmail = email;
                finalMobileCountryCode =
                    userData?.user?.mobileCountryCode || '';
                finalMobileNumber = userData?.user?.mobileNumber || '';
            } else {
                // Phone input was visible
                finalEmail = userData?.user?.email || '';
                finalMobileCountryCode = currentCountry?.dialCode || '';
                finalMobileNumber = getCurrentMobileWithoutCountryCode();
            }

            // Build payload based on config
            let registrationData = {
                name: name,
                email: finalEmail,
                mobileCountryCode: finalMobileCountryCode,
                mobileNumber: finalMobileNumber,
                companyName: companyType === 'COMPANY' ? companyName : '',
                type: companyType,
                mailingAddress: {
                    line1: addressLine1,
                    line2: addressLine2,
                    city: city,
                    state: stateVal,
                    pincode: pincode,
                    country: country
                }
            };

            // Add PAN or RERA based on config
            if (config?.loginModal?.skipReraNumberValidation === true) {
                // Show PAN, hide RERA
                registrationData.pan = panNumber;
            } else {
                // Show RERA, hide PAN
                registrationData.reraDocumentDtoList = reraNumber ? [{
                    documentNumber: reraNumber,
                    expiryDate: '',
                    externalId: '',
                    fileKey: '',
                    folder: '',
                    issueDate: '',
                    link: '',
                    name: 'RERA Document',
                    rejectionReason: '',
                    state: stateVal,
                    status: 'PENDING_APPROVAL',
                    type: 'RERA'
                }] : [];
            }

            // console.log('🚀 API Payload being sent for registration:', registrationData);
            
            setLoading(true);
            winnreAuth({
                method: 'post',
                url: 'winnre/cp/channelPartner/registration',
                data: registrationData
            })
                .then((res) => {
                    // console.log('registration Response:', res);
                    setLoading(false);
                    
                    if (res.status === 'FAILED') {
                        setShowErrorAlert(true);
                        setAlertMessage(res.message);
                        return;
                    }
                    if (res.user) {
                        window?.webengage?.track('RegistrationFormSubmitted');
                        if (config?.autoLogout) {
                            sessionStorage.setItem(
                                'refreshToken',
                                res.refreshToken
                            );
                            sessionStorage.setItem(
                                'accessToken',
                                res.accessToken
                            );
                        } else {
                            localStorage.setItem(
                                'refreshToken',
                                res.refreshToken
                            );
                            localStorage.setItem(
                                'accessToken',
                                res.accessToken
                            );
                        }
                        dispatch(
                            authActions.authenticationToken(res.accessToken)
                        );
                        // setAuthToken(res.accessToken);
                        dispatch(
                            authActions.setUserData({
                                userDetails: {
                                    mobileCountryCode:
                                        res.user.mobileCountryCode,
                                    mobileNumber: res.user.mobileNumber,
                                    email: res.user.email,
                                    status: res?.user?.status,
                                    preferredName: res?.user?.preferredName,
                                    birthDate: res?.user?.dateOfBirth,
                                    address: res?.address
                                },
                                name: res?.user?.name,
                                userRole: 'CHANNEL_PARTNER',
                                userId: res?.user?.id,
                                hashId: res?.user.hashId,
                                profileCompletionPercentage:
                                    res?.user?.profileCompletionPercentage,
                                finishedFirstTimeLoginGuide:
                                    res?.user?.finishedFirstTimeLoginGuide
                            })
                        );
                        dispatch(authActions.login());
                        dispatch(authActions.closeLoginModal());
                        history.push('/myprofile/docs');
                    } else {
                        setShowErrorAlert(true);
                        setAlertMessage(res.message);
                        return;
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    setShowErrorAlert(true);
                    setAlertMessage(
                        err?.response?.data?.message || 'Something went wrong.'
                    );
                });
            return;
        }
    };
    return (
        <>
            <div
                className={`flex justify-between px-8 pb-4 ${config?.loginModal.border} `}
            >
                <h1
                    className={`self-center text-lg md:text-2xl font-semibold ${config?.loginModal.text} `}
                >
                    Sign up
                </h1>
                <BsXCircle
                    onClick={closeLoginModal}
                    className={`self-center h-5 w-5 cursor-pointer ${config?.loginModal.text} `}
                />
            </div>

            <div className="px-8 pt-4 overflow-y-auto max-h-[65vh] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 relative">
                {loading && (
                    <div className="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center z-50">
                        <LoadingSpinner />
                    </div>
                )}
                <p
                    className={`w-full lg:w-[85%] text-sm lg:text-base font-semibold ${config?.loginModal.text} `}
                >
                    Please enter your details
                </p>
                <form className="w-full">
                    {/* NAME */}
                    <div className={`mt-4 mb-2 md:mb-2 relative`}>
                        <input
                            type="text"
                            id="otp"
                            className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                            placeholder="name*"
                            onChange={nameChangedHandler}
                            onBlur={nameBlurHandler}
                            value={name}
                            autoComplete="off"
                        />
                        <label
                            htmlFor="text"
                            className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                        >
                            {config?.name === 'Godrej' ? 'Influencer' : 'CP'}{' '}
                            Name*
                        </label>
                        {nameHasError && (
                            <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                {`Please enter a valid Name`}
                            </p>
                        )}
                    </div>

                    {/* Company Type */}
                    <div className="mb-2 md:mb-2">
                        <Select
                            options={[
                                { value: 'COMPANY', label: 'COMPANY' },
                                { value: 'INDIVIDUAL', label: 'INDIVIDUAL' }
                            ]}
                            onChange={(selected) =>
                                setCompanyType(selected.value)
                            }
                            value={{ value: companyType, label: companyType }}
                            placeholder="Company Type*"
                        />
                    </div>

                    {/* Company Name */}
                    {companyType === 'COMPANY' && (
                        <div className={`mb-2 md:mb-2 relative`}>
                            <input
                                type="text"
                                id="companyName"
                                className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                                placeholder="Company Name (as per PAN)"
                                onChange={companyNameChangedHandler}
                                onBlur={companyNameBlurHandler}
                                value={companyName}
                                autoComplete="off"
                            />
                            <label
                                htmlFor="companyName"
                                className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                            >
                                Company Name (as per PAN)*
                            </label>
                        </div>
                    )}

                    {/* PAN Number */}
                    {config?.loginModal?.skipReraNumberValidation === true && (
                         <div className={`mb-2 md:mb-2 relative`}>
                        <input
                            type="text"
                            id="panNumber"
                            className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                            placeholder={
                                companyType === 'COMPANY'
                                    ? 'Company PAN Number*'
                                    : 'PAN Number*'
                            }
                            onChange={panNumberChangedHandler}
                            onBlur={panNumberBlurHandler}
                            value={panNumber}
                            autoComplete="off"
                        />
                        <label
                            htmlFor="panNumber"
                            className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                        >
                            {companyType === 'COMPANY'
                                ? 'Company PAN Number*'
                                : 'PAN Number*'}
                        </label>
                        {panNumberHasError && (
                            <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                Please enter a valid{' '}
                                {companyType === 'COMPANY' ? 'company' : ''} PAN
                                number
                            </p>
                        )}
                    </div>
                    )}
                   

                    {/* RERA Number */}
                    {config?.loginModal?.skipReraNumberValidation === false && (
                        <div className={`mb-2 md:mb-2 relative`}>
                            <input
                                type="text"
                                id="reraNumber"
                                className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                                placeholder="RERA Number*"
                                onChange={reraNumberChangedHandler}
                                onBlur={reraNumberBlurHandler}
                                value={reraNumber}
                                autoComplete="off"
                            />
                            <label
                                htmlFor="reraNumber"
                                className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                            >
                                RERA Number*
                            </label>
                            {reraNumberHasError && (
                                <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                    Please enter a valid RERA number
                                </p>
                            )}
                        </div>
                    )}
                   

                    {/* Company Type */}
                    {/*   <div className={`mb-2 md:mb-2 relative`}>
                        <Select
                            options={companyTypes}
                            onChange={setCompanyType}
                            value={companyType}
                            placeholder="Company Type"
                        />
                    </div> */}

                    {/* EMAIL */}
                    {!isInternationalCustomer && !loginWithEmail ? (
                        <div className={`mb-2 md:mb-2 relative`}>
                            <input
                                type="email"
                                id="email"
                                className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                                placeholder="name@example.com"
                                onChange={emailChangedHandler}
                                onBlur={emailBlurHandler}
                                value={email}
                                autoComplete="off"
                            />
                            <label
                                htmlFor="email"
                                className="peer-placeholder-shown:opacity-100  opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                            >
                                {selectedOption === 'COMPANY'
                                    ? 'Company Email Address *'
                                    : 'Email address *'}
                            </label>
                            {emailHasError && (
                                <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                    Please enter a valid email address
                                </p>
                            )}
                        </div>
                    ) : (
                        <div
                            className={` w-full flex flex-col mx-auto mb-2 md:mb-5'
          relative`}
                        >
                            {/* <label className="block text-sm md:text-base tracking-wide self-centre text-gray-600 ">
            Enter your mobile number
        </label> */}
                            <PhoneInput
                                // disabled={isOtpSent}
                                country="in"
                                countryCodeEditable={false}
                                containerClass={
                                    'peer py-3 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full  h-12 placeholder-transparent'
                                }
                                containerStyle={{
                                    width: '100%',
                                    border: '2px solid grey !important',
                                    outline: 'none'
                                }}
                                buttonStyle={{
                                    backgroundColor: 'white',
                                    border: 'none'
                                }}
                                inputStyle={{
                                    width: '100%',
                                    height: 'auto',
                                    border: 'none',
                                    outline: 'none',
                                    paddingLeft: '44px',
                                    fontSize: '16px'
                                }}
                                isValid={currentMobileValidtor}
                                onChange={currentMobileOnChange}
                                value={currentMobile}
                                enableSearch
                                onBlur={() => {
                                    setCurrentMobileIsTouched(true);
                                    setCurrentMobileInputFocused(false);
                                }}
                                onFocus={() =>
                                    setCurrentMobileInputFocused(true)
                                }
                                inputClass="border border-gray-300"
                            />
                            {currentMobileHasError && (
                                <p
                                    className={` text-left text-sm mt-1 font-Roboto text-red-400`}
                                >
                                    Please enter a valid number
                                </p>
                            )}
                        </div>
                    )}

                    {/* Address Line 1 */}
                    <div className={`mb-2 md:mb-2 relative`}>
                        <input
                            type="text"
                            id="addressLine1"
                            className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                            placeholder="Registered Company Address Line 1*"
                            onChange={addressLine1ChangedHandler}
                            onBlur={addressLine1BlurHandler}
                            value={addressLine1}
                            autoComplete="off"
                        />
                        <label
                            htmlFor="addressLine1"
                            className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                        >
                            {companyType === 'COMPANY'
                                ? 'Registered Company'
                                : ''}{' '}
                            Address Line 1*
                        </label>
                        {addressLine1HasError && (
                            <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                Please enter an address
                            </p>
                        )}
                    </div>

                    {/* Address Line 2 */}
                    <div className={`mb-2 md:mb-2 relative`}>
                        <input
                            type="text"
                            id="addressLine2"
                            className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                            placeholder="Address Line 2"
                            onChange={addressLine2ChangedHandler}
                            onBlur={addressLine2BlurHandler}
                            value={addressLine2}
                            autoComplete="off"
                        />
                        <label
                            htmlFor="addressLine2"
                            className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                        >
                            Address Line 2
                        </label>
                    </div>

                    {/* State */}
                    {isInternationalCustomer || loginWithEmail ? (
                        <div className={`mb-2 md:mb-2 relative`}>
                            <input
                                type="text"
                                id="state"
                                className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                                placeholder="State*"
                                onChange={stateChangedHandler}
                                onBlur={stateBlurHandler}
                                value={stateVal}
                                autoComplete="off"
                            />
                            <label
                                htmlFor="state"
                                className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                            >
                                State*
                            </label>
                            {stateHasError && (
                                <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                    Please enter a state
                                </p>
                            )}
                        </div>
                    ) : (
                        <div className={`mb-2 md:mb-2 relative`}>
                            <Select
                                options={stateList.map((s) => ({
                                    value: s.code,
                                    label: s.name
                                }))}
                                onChange={(selected) =>
                                    stateChangedHandler({
                                        target: { value: selected.value }
                                    })
                                }
                                value={stateList
                                    .map((s) => ({
                                        value: s.code,
                                        label: s.name
                                    }))
                                    .find((s) => s.value === stateVal)}
                                placeholder="State*"
                            />
                            {stateHasError && (
                                <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                    Please select a state
                                </p>
                            )}
                        </div>
                    )}

                    {/* City */}
                    {isInternationalCustomer ||
                    loginWithEmail ||
                    cityList.length === 0 ? (
                        <div className={`mb-2 md:mb-2 relative`}>
                            <input
                                type="text"
                                id="city"
                                className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                                placeholder="City"
                                onChange={cityChangedHandler}
                                onBlur={cityBlurHandler}
                                value={city}
                                autoComplete="off"
                            />
                            <label
                                htmlFor="city"
                                className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                            >
                                City
                            </label>
                        </div>
                    ) : (
                        <div className={`mb-2 md:mb-2 relative`}>
                            <Select
                                options={cityList.map((s) => ({
                                    value: s.name,
                                    label: s.name
                                }))}
                                onChange={(selected) =>
                                    cityChangedHandler({
                                        target: { value: selected.value }
                                    })
                                }
                                value={
                                    city
                                        ? cityList
                                              .map((s) => ({
                                                  value: s.name,
                                                  label: s.name
                                              }))
                                              .find((s) => s.value === city)
                                        : null
                                }
                                placeholder="City*"
                            />
                        </div>
                    )}

                    {/* Pincode */}
                    <div className={`mb-2 md:mb-2 relative`}>
                        <input
                            type="text"
                            id="pincode"
                            className="peer pt-8 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full p-3 h-12 placeholder-transparent"
                            placeholder="Pincode"
                            onChange={pincodeChangedHandler}
                            onBlur={pincodeBlurHandler}
                            value={pincode}
                            autoComplete="off"
                        />
                        <label
                            htmlFor="pincode"
                            className="peer-placeholder-shown:opacity-100 opacity-75 peer-focus:opacity-75 peer-placeholder-shown:scale-100 scale-75 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 -translate-y-3 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 translate-x-1 peer-focus:translate-x-1 absolute top-0 left-0 px-3 py-3 h-full pointer-events-none transform origin-left transition-all duration-100 ease-in-out"
                        >
                            Pincode*
                        </label>
                        {pincodeHasError && (
                            <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                Pincode must be 6 digits
                            </p>
                        )}
                    </div>

                    {/* Country */}
                    <div className={`mb-2 md:mb-2 relative`}>
                        <Select
                            options={options}
                            value={options.find(
                                (option) => option.label === country
                            )}
                            onChange={(option) =>
                                countryChangedHandler({
                                    target: { value: option.label }
                                })
                            }
                            placeholder="Country*"
                            isDisabled={
                                !isInternationalCustomer && !loginWithEmail
                            }
                        />
                        {countryHasError && (
                            <p className="text-left text-sm mt-1 font-Roboto text-red-400">
                                Please select a country
                            </p>
                        )}
                    </div>

                    <div className=" flex justify-between">
                        <button
                            disabled={loading}
                            onClick={backClickedHandler}
                            className={`w-auto ${config?.loginModal.buttonBg} text-white py-2 px-4 md:px-8 rounded-md mb-5 disabled:opacity-50 disabled:cursor-not-allowed`}
                        >
                            Back
                        </button>
                        <button
                            disabled={!formIsValid || loading}
                            onClick={registrationHandler}
                            className={`w-auto ${config?.loginModal.buttonBg} text-white py-2 px-4 md:px-8 rounded-md mb-5  disabled:hover:text-white disabled:opacity-90 disabled:bg-gray-400 disabled:cursor-not-allowed`}
                        >
                            Register
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}

export default SignUp;
